import { z } from "zod";

import { DocumentSectionSchema } from "@entities/document";

import { DynamicZoneSchema } from "@shared/content-types/schemas/dynamicZone.schema";
import { SeoSchema } from "@shared/content-types/schemas/seo.schema";

export const DocumentPageSchema = z.object({
  id: z.number().int().positive(),
  slug: z.string().min(1),
  documentId: z.string().min(1),
  createdAt: z.string().datetime(),
  updatedAt: z.string().datetime(),
  publishedAt: z.string().datetime(),
  title: z.string().min(1),
  content: DynamicZoneSchema.optional(),
  viewUpdatedAt: z.boolean(),
  otherDocuments: DocumentSectionSchema.optional(),
  seo: SeoSchema.optional().nullable(),
});
